import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText, TwoColumnsList } from "../../models";
import { BlockHeader } from "../../../common/block-header/BlockHeader";
import { Lists } from "./components/lists/Lists";

type Props = {
  title: RichText;
  lists: TwoColumnsList[];
};

export const AccordionList: FC<Props> = ({ title, lists }) => (
  <div
    className={classNames(
      "mt-20 w-full px-5",
      "lg:mt-25 lg:px-16",
      "xl:mt-40 xl:px-24",
      "xxl:mx-auto xxl:max-w-container xxl:px-0",
    )}
  >
    <div className="xxl:mx-auto xxl:w-[83%]">
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <BlockHeader
          richText={title}
          className={classNames(
            "text-medium text-primary-content mb-5",
            "lg:mb-15",
            "xl:text-large",
          )}
        />
      </Fade>
      <Lists lists={lists} />
    </div>
  </div>
);
